var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");

var ErrorMessageModel = function (options) {
    ui_extensions.AbstractUIModel.apply(this, arguments);

    this.errorMessage = this.value("errorMessage", true);
    this.isExpectedError = this.value("isExpectedError", true);
    this.reload_on_critical_error = this.value("reload_on_critical_error", true);
    this.popup_on_error = this.value("popup_on_error", true);

    if(options.reload_on_critical_error !== undefined)
        this.reload_on_critical_error(options.reload_on_critical_error);
    else
        this.reload_on_critical_error(true);
    if(options.popup_on_error !== undefined)
        this.popup_on_error(options.popup_on_error);
    else
        this.popup_on_error(true);

    //register "singleton" to be accessed from lib-core
    window.errorMessageModel = this;    // TODO: remove global function!!
};
lib_core.inherit(ErrorMessageModel, ui_extensions.AbstractUIModel);
ErrorMessageModel.$class = "ErrorMessageModel";

module.exports = ErrorMessageModel;

ErrorMessageModel.prototype.initialize = function () {
};

ErrorMessageModel.prototype.logErrorMessage = function(errorMessage, concatinate) {

    // if no popup is required for this error, do not show
    if(this.requiresPopup(errorMessage)){
        if(concatinate === false) {
            this.errorMessage(null);
            this.errorMessage(errorMessage);
            this.isExpectedError(errorMessage.isExpectedError);
        } else if(concatinate === true){
            var errorObj = this.errorMessage();
            this.errorMessage(null);
            errorObj.message += errorMessage.message;
            if(lib_core.logError.isMoreCriticalThan(errorMessage.criticality, errorObj.criticality)) errorObj.criticality = errorMessage.criticality;
            this.errorMessage(errorObj);
            this.isExpectedError(errorMessage.isExpectedError);
        } else {
            // do not display error
            // possibly show underneath current error, but not possible yet.
        }
    }
};

ErrorMessageModel.prototype.errorMessageClosed = function() {
    this.errorMessage(null);
    this.isExpectedError(null);
};



ErrorMessageModel.prototype.willBeConcatinated = function (error, isExpectedError) {
    // server errors are never the result of another error, so they are never concatinated.
    // always throw as new.
    if(error["status"] !== undefined) return false;

    // if there is currently no error message, or the current error message is expected and my new one is not.
    if(!this.errorMessage() || (this.isExpectedError() === true && isExpectedError === false) )
    {
        // do not concatinate (throw new error)
        return false;
    }
    // if the current error is not expected (real error) and this one is expected (just a mesege)
    else if( (this.isExpectedError() === false && isExpectedError === true) )
    {
        // don't show the messege.
        return null;
    }
    else
    {   // concatinate
        return true;     
    }
};

ErrorMessageModel.prototype.requiresPopup = function (errorMessage) {
    if(!this.popup_on_error()) return false;
    if(errorMessage.criticality === lib_core.logError.criticality.MAJOR) return true;
    if(errorMessage.criticality === lib_core.logError.criticality.CRITICAL) return true;
    if(errorMessage.criticality === lib_core.logError.criticality.BLOCKING) return true;
    return false;
};


